<div class="page-container">
  <div class="top-section sticky-header">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="stock-title">Stock Unit Search</h1>
      <button
        style="color: #037493; border: 1px solid #c1c5cb; margin-right: 35px"
        (click)="openStockSheetModal()"
      >
        <ds-icon icon="download" class="icon-align"></ds-icon>
        <div class="align_btn">Download Stock Sheet</div>
      </button>
    </div>

    <div class="align_bread" style="margin-top: 5px">
      <app-breadcrumb
        *ngIf="criteriaData"
        [externalData]="criteriaData"
      ></app-breadcrumb>
    </div>

    <div class="error-banner" *ngIf="criteriaLoadError">
      <div class="error-text">{{ criteriaLoadError }}</div>
      <ds-button (click)="retryCriteriaLoad()">Retry</ds-button>
    </div>

    <div class="error-banner error-banner--compact" *ngIf="downloadError">
      <div class="error-text">{{ downloadError }}</div>
    </div>

    <div
      style="
        margin-top: -35px;
        margin-bottom: 10px;
        float: right;
        margin-right: 35px;
      "
      class="d-flex justify-content-start align-items-center"
    >
      <a
        class="clear-filters-link"
        style="margin-right: 20px"
        href="#"
        (click)="toggleFilterVisibility(); $event.preventDefault()"
      >
        <ds-icon [icon]="showFilters ? 'eye_off' : 'eye'"></ds-icon>
        <div class="align_clear">
          {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
        </div>
      </a>

      <a
        class="clear-filters-link"
        href="#"
        (click)="clearAllFilters(); $event.preventDefault()"
      >
        <ds-icon icon="filter_delete"></ds-icon>
        <div class="align_clear">Clear Filters</div>
      </a>
    </div>

    <br />
    <app-results-count></app-results-count>
  </div>

  <div class="align_filters" *ngIf="showFilters && criteriaData">
    <app-filters
      #filtersComp
      [externalData]="criteriaData"
      (filtersChanged)="onFiltersChanged($event)"
      (searchClicked)="searchClicked()"
      (modelSelected)="onModelSelected($event)"
    ></app-filters>
  </div>

  <div style="height: 60px"></div>

  <div class="content_bg styled-section" *ngIf="showTabs">
    <table class="scrollable-table">
      <app-tabs [isModelSelected]="selectedModel !== null && selectedModel !== ''" [requestPayload]="requestPayload"></app-tabs>
    </table>
    <br />
  </div>
</div>

<ds-modal
  #stockSheetModal
  [ds-modal-trigger-for]="stockSheetModal"
  [(isModalOpen)]="stockSheetModalIsOpen"
  [dimensionsConfig]="{ width: '585px', height: 'auto' }"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Download Stock Sheet
  </ds-box-header>
  <ds-box-content>
    <div>
      <span>
        You are about to download a stocksheet, please allow some time for the
        sheet to process.
      </span>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <ds-button (click)="downloadStockSheet()"> Download Stock Sheet </ds-button>
  </ds-box-footer>
</ds-modal>
